import { GroupSetting } from '@griply/types';
import { createContext, useContext } from 'react';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';

export type DeadlineDeadlineRenderData = {
  groupSettings: GroupSetting;
  tasksMap: Record<ID, Task>;
  tasks: Task[];
  overdueTasks: Task[];
  today: Date;
  denseFormat?: boolean;
};

export const DeadlineDeadlineRenderDataContext =
  createContext<DeadlineDeadlineRenderData | null>(null);

export const useDeadlineDeadlineRenderData = (): DeadlineDeadlineRenderData => {
  const data = useContext(DeadlineDeadlineRenderDataContext);
  if (!data) {
    throw new Error(
      'useDeadlineDeadlineRenderData must be used within a DeadlineDeadlineGroupingTasksList',
    );
  }
  return data;
};
